(ns hai.chats.routes
  (:require
   [hai.ui.icons :as icons]
   [hai.chats.api :as api]
   [hai.chats.components.interface :as chat-interface]
   [hai.ui.rf-sugar :refer [>e]]
   [hai.web-app.routing :as-alias routing]
   [lambdaisland.glogi :as log]))

(defn routes []
  [["/chats" {:name        :tasks/chats
              ::routing/window-title "Chat with AI"
              :label       "Chat with AI"
              :breadcrumbs ["Chat with AI"]
              :icon        icons/outlined-chat_bubble
              :view        chat-interface/new-chat-page
              :controllers [{:start (fn [] (>e [::api/on-navigate-all]))}]}]
   ["/chats/:id" {:name :tasks/chats-by-id
                  ::routing/window-title "Chat"
                  :view chat-interface/chat-page
                  :controllers [{:parameters {:path [:id]}
                                 :start (fn [{path :path}]
                                          (>e [::api/on-navigate-by-id (parse-uuid (:id path))]))
                                 :stop (fn [{_path :path}]
                                         (log/info ::stop-controller true)
                                         (>e [::api/stream-cancel]))}]}]])
